<div class="row-wrap my_subscriptions_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
  fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="50px">
  <ng-container *ngIf="userSubscriptions; else loadingTemplate">
    <ng-container *ngIf="userSubscriptions.length; else noDataTemplate">
      <section style="width: 100%;">
        <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div class="my_subscriptions_column bgW_borRed" fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100"
      fxFlex.xs="100" fxFlexFill>
      <div class="my_subscriptions_box " fxLayoutAlign.gt-sm="space-between center" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
      fxLayout.sm="row" fxLayout.xs="column" fxLayoutGap="20px" [ngClass]="{'active': currentSubscription?.showActive}">
        
      <div        fxFlex.gt-sm="none" 
  fxFlex.lt-md="100" 
  style="width: 400px;">
        <div class="media plan_name_anf_crown">
          <div class="media-left">
            <img src="../../../assets/images/icons/crown.svg" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{currentSubscription?.subscription_plan?.name}}</h4>
                       <p class="booking_id">Expires on : {{currentSubscription?.expires_at | date}}</p>
            <!-- <button type="submit" class="btn btn-sm global-btn" mat-button>Expires on
          {{subDetails?.expires_at | date}}</button>     -->
            <!--<button type="submit" class="btn btn-sm global-btn" mat-button>View Plan Details</button>-->
          </div>
        </div>
        <div class="my_subscriptions_body">
          <h3>Invoice to:</h3>
          <h5>{{loginDetails?.name}}</h5>
        <p class="value" *ngIf="loginDetails?.address?.addressName">{{loginDetails?.address?.addressName}}</p>
                <p class="value" *ngIf="loginDetails?.address?.addressName">{{loginDetails?.address?.addressName}}</p>
          <!-- <p class="booking_date">Booking date : {{subDetails?.created_at | date}}</p> -->
         

       
        </div>
        <div class="upgrader_Card_plan_btn mt-4">
        <button mat-stroked-button class="buttonBlu" *ngIf="currentSubscription?.showActive" (click)="update_card()">Update Card</button>
        <button mat-stroked-button class="buttonBlu" *ngIf="!currentSubscription?.showActive" (click)="renew()">Renew Plan</button>
        <button mat-stroked-button class="buttonBlu" *ngIf="currentSubscription?.showActive" (click)="cancelSubscription()">Cancel Plan</button>
<button
  mat-stroked-button
  class="buttonOrg"
  [disabled]="isUpgradeLoading"
  (click)="openUpgradeModal()"
>
  {{ isUpgradeLoading ? 'Loading...' : 'Upgrade Plan' }}
</button>
      </div>

      </div>
      <div       fxFlex.gt-sm="none" 
  fxFlex.lt-md="100" 
  style="width: 300px;">
         <img   src="../../../../../assets/images/card-detail.svg"  width="300px">
        <!-- <div class="auto_renew_toggle">Auto renewal<mat-slide-toggle
        class="example-margin"
        [color]="color"
        [checked]="checked"
        [disabled]="disabled">
     
    </mat-slide-toggle>
  </div> -->
      </div>
     

      </div>
  
    </div>
    </div>
    </section>
    </ng-container>
  </ng-container>
  <ng-template #loadingTemplate>
    <div class="custom-loader ">
      <div class="custom-loader custom_logo_loader">
        <img src='../../../../../images2/loader.gif' alt="img" loading="lazy" />
      </div>
    </div>

  </ng-template>
  <ng-template #noDataTemplate>
          <div class="my_subscriptions_column bgW_borRed" fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100"
      fxFlex.xs="100" fxFlexFill>
      <div class="my_subscriptions_box " fxLayoutAlign.gt-sm="space-between center" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
      fxLayout.sm="row" fxLayout.xs="column" fxLayoutGap="20px">
        
      <div        fxFlex.gt-sm="none" 
  fxFlex.lt-md="100" 
  style="width: 400px;">
        <div class="media plan_name_anf_crown">
          <div class="media-left">
            <img src="../../../assets/images/icons/crown.svg" class="media-object">
          </div>
          <div class="media-body">
            <h4 class="media-heading">{{currentSubscription?.name}}</h4>
                       <p class="booking_id">Expires on : Free Plan</p>
            <!-- <button type="submit" class="btn btn-sm global-btn" mat-button>Expires on
          {{subDetails?.expires_at | date}}</button>     -->
            <!--<button type="submit" class="btn btn-sm global-btn" mat-button>View Plan Details</button>-->
          </div>
        </div>
        <div class="my_subscriptions_body">
          <h3>Invoice to:</h3>
          <h5>{{loginDetails?.name}}</h5>
        <p class="value" *ngIf="loginDetails?.address?.addressName">{{loginDetails?.address?.addressName}}</p>
                <p class="value" *ngIf="loginDetails?.address?.addressName">{{loginDetails?.address?.addressName}}</p>
          <!-- <p class="booking_date">Booking date : {{subDetails?.created_at | date}}</p> -->
         

       
        </div>
        <div class="upgrader_Card_plan_btn mt-4">
        <!-- <button mat-stroked-button class="buttonBlu" *ngIf="currentSubscription.showActive" (click)="update_card()">Update Card</button>
        <button mat-stroked-button class="buttonBlu" *ngIf="!currentSubscription.showActive" (click)="renew()">Renew Plan</button>
        <button mat-stroked-button class="buttonBlu" *ngIf="currentSubscription.showActive" (click)="cancelSubscription()">Cancel Plan</button> -->
        <button mat-stroked-button class="buttonOrg" (click)="openUpgradeModal()">Upgrade Plan</button>
      </div>

      </div>
      <div       fxFlex.gt-sm="none" 
  fxFlex.lt-md="100" 
  style="width: 300px;">
         <img   src="../../../../../assets/images/card-detail.svg"  width="300px">
        <!-- <div class="auto_renew_toggle">Auto renewal<mat-slide-toggle
        class="example-margin"
        [color]="color"
        [checked]="checked"
        [disabled]="disabled">
     
    </mat-slide-toggle>
  </div> -->
      </div>
     

      </div>
  
    </div>










  </ng-template>
</div>

<section>
  <div class="bgW_borRed " style="padding: 15px;">
    <h3>Transactions</h3>
            <div class="table_section">

              <div class="table_header mt-0">
<div class="table_header_left">
<!-- SEARCH -->
<div class="table_search_box">
<div class="custom-form-group">
  <div class="custom-form-control cSeach" style="margin-left: 10px;">
    <mat-form-field appearance="outline">
      <input
        type="search"
     
        (keyup)="applyFilter($event.target.value)"
        matInput
        placeholder="Search" />
      <mat-icon matSuffix>
        <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="img" class="search-icon" />
      </mat-icon>
    </mat-form-field>
  </div>
</div>
</div>
</div>
</div>

            
           <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
<perfect-scrollbar>
<table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows> 

<!-- S.No Column -->
<ng-container matColumnDef="sNo">
  <th mat-header-cell *matHeaderCellDef><span class="tab_head">S.No</span></th>
 <td mat-cell *matCellDef="let element; let rowIndex = dataIndex">
  {{ rowIndex + 1 }}
</td>
</ng-container>

<!-- Plan Name -->
<ng-container matColumnDef="planName">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>PLAN NAME</th>
  <td mat-cell *matCellDef="let element" data-label="PLAN NAME">{{ element?.subscription_plan?.name }}</td>
</ng-container>

<!-- Plan Price -->
<ng-container matColumnDef="planPrice">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>PLAN PRICE</th>
  <td mat-cell *matCellDef="let element" data-label="PLAN PRICE">AUD {{ element?.total_amount }}</td>
</ng-container>

<!-- Start Date -->
<ng-container matColumnDef="startDate">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>START DATE</th>
  <td mat-cell *matCellDef="let element" data-label="START DATE">{{ element?.created_at | date: 'dd/MM/yyyy' }}</td>
</ng-container>

<!-- End Date -->
<ng-container matColumnDef="endDate">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>END DATE</th>
  <td mat-cell *matCellDef="let element" data-label="END DATE">{{ element?.expires_at | date: 'dd/MM/yyyy' }}</td>
</ng-container>
 <ng-container matColumnDef="invoiceId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>INVOICE ID</th>
    <td mat-cell *matCellDef="let element" data-label="Invoice Id">
      {{ element?.id }}
    </td>
  </ng-container>
<!-- Status -->
<ng-container matColumnDef="status">
<th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
<td mat-cell *matCellDef="let element" data-label="STATUS">
<span class="status-badge" [ngClass]="{
'unblocked': isActive(element?.expires_at),
'blocked': !isActive(element?.expires_at)
}">
{{ isActive(element?.expires_at) ? 'ACTIVE' : 'EXPIRED' }}
</span>
</td>
</ng-container>

<!-- Action -->
<ng-container matColumnDef="action">
<th mat-header-cell *matHeaderCellDef><span class="tab_head">ACTION</span></th>
<td mat-cell *matCellDef="let element" data-label="action" (click)="$event.stopPropagation()" style="pointer-events:all;">
<button mat-icon-button [matMenuTriggerFor]="menu">
<mat-icon>more_vert</mat-icon>
</button>

<mat-menu #menu="matMenu" class="table-action-btn">


<!-- Invoice View -->
<!--   <button type="button" mat-menu-item (click)="viewInvoice(element)">
  <mat-icon>receipt</mat-icon>
  <span>Invoice</span>
</button> -->

<!-- Download PDF -->
<button type="button" mat-menu-item (click)="handleInvoice(element, 'download')">
 <mat-icon>cloud_download</mat-icon>
  <span>Download</span>
</button>

<!-- Cancel Plan -->
<button type="button" mat-menu-item  (click)="handleInvoice(element, 'email')">
  <mat-icon>mail</mat-icon>
  <span>Email</span>
</button>
</mat-menu>
</td>
</ng-container>

<!-- Header and Row -->
<tr mat-header-row *matHeaderRowDef="subscriptionDisplayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: subscriptionDisplayedColumns;"></tr>

</table>
</perfect-scrollbar>
</div>

            
          </div>

  </div>
</section>



<div *ngIf="isLoading" class="loader-overlay">
   <div class="custom-loader custom_logo_loader">
    <img src='../../../../../assets/images2/loader.gif' alt="Loading..." loading="lazy" />
  </div>
</div>
